<template>
   <div class="baseindex">
      <!-- 轮播图 -->
      <div class="base">
         <div class="block">
            <el-carousel height="580px">
               <el-carousel-item v-for="(item,index) in imgList" :key="index">
                  <!-- <h3 class="small">{{ item.a }}</h3> -->
                  <!--<img :src="item.adContent" alt="" class="carousel_img">-->
                  <div class="banner_item" :style="'background-image:url('+item.adContent+')'">
                     <!-- <a :href="item.adLink" v-if="item.adLink != null"></a> -->
                  </div>
               </el-carousel-item>
            </el-carousel>
         </div>
      </div>
      <div class="Experts">
         <div class="Experts_1">
            <h1>Founders and Experts</h1>
            <img src="../../assets/images/isfal/10004.jpg" alt="">
         </div>
      </div>
      <div class="cumulative">
         <div class="cumulative_box">

            <div class="cumulative_1">
               <div class="cumulative_1_1">
                  <p class="iconfont">&#xe635;</p>
                  <p class="num">6</p>
                  <p class="name">Continents</p>
               </div>
               <div class="cumulative_1_1">
                  <p class="iconfont">&#xe635;</p>
                  <p class="num">60</p>
                  <p class="name">Countries</p>
               </div>
               <div class="cumulative_1_1">
                  <p class="iconfont">&#xe635;</p>
                  <p class="num">200</p>
                  <p class="name">Accumulated Professional Years</p>
               </div>
               <div class="cumulative_1_1">
                  <p class="iconfont">&#xe635;</p>
                  <p class="num">600</p>
                  <p class="name">Clients</p>
               </div>
               <div class="cumulative_1_1">
                  <p class="iconfont">&#xe635;</p>
                  <p class="num">500</p>
                  <p class="name">Organizations</p>
               </div>
               <div class="cumulative_1_1">
                  <p class="iconfont">&#xe635;</p>
                  <p class="num">9150</p>
                  <p class="name">Action Learning
                     Facilitators</p>
               </div>
            </div>
            <div class="cumulative_2">The cumulative achievements of the founders and the team of experts in the field
               of action learning
            </div>
         </div>
      </div>
      <div class="Alliance">
         <div class="Alliance_box">
            <h1>Strategic partners & Ecological Alliance</h1>
            <div class="images_box">
               <div class="images_box_1" v-for="(item,index) in imageslogo" :key="index">
                  <img :src="item" alt="">
               </div>
            </div>
         </div>
      </div>
      <div class="malf">
         <div class="malf_box">
            <h1>Certification</h1>
            <img src="../../assets/images/isfal/100015.jpg" alt="">
         </div>
      </div>


   </div>
</template>
<script>
   import "@/assets/css/index.less"

   import {
      mapState
   } from "vuex";
   export default {
      name: 'page_index202305',
      components: {},
      computed: {
         ...mapState({
            "loginStatus": state => state.user.loginStatus,
         }),
      },

      data() {
         return {
            imageslogo: [
               require('@/assets/images/isfal/10007.jpg'),
               require('@/assets/images/isfal/10008.jpg'),
               require('@/assets/images/isfal/10009.jpg'),
               require('@/assets/images/isfal/10010.jpg'),
               require('@/assets/images/isfal/10011.jpg'),
               require('@/assets/images/isfal/10012.jpg'),
               require('@/assets/images/isfal/10013.jpg'),
               require('@/assets/images/isfal/10014.png')
            ],
            // 轮播图数组
            imgList: [{
                  adContent: require('@/assets/images/isfal/10001.jpg'),
               },
               {
                  adContent: require('@/assets/images/isfal/10002.jpg'),
               },
               {
                  adContent: require('@/assets/images/isfal/10003.jpg'),
               }

            ],


         }
      },
      watch: {
         $route() {

         }
      },
      mounted() {

      },
      methods: {




      }
   }
</script>
<style lang="less" scoped>
</style>